import React from 'react'
import { Card, CardActionArea, CardMedia, CardContent, Typography, Chip } from '@material-ui/core'
import moment from 'moment'
import { Redirect } from 'react-router'

class ArticleCard extends React.Component {
    state = {
        redirectURL: null
    }

    handleArticleClick = () => {
        console.log("clicked")
        this.setState({ redirectURL: this.props.article.pdfURL })
    }

    returnRedirect = () => {
        if (this.state.redirectURL) {
            return (
                <Redirect to={`${this.state.redirectURL}`} />
            )
        }
    }

    render() {
        const { article } = this.props
        const styles = {
            media: {
                height: 300
            },
            chip: {
                marginTop: 5,
                marginBottom: 5,
                marginRight: 5
            }
        }
        return (
            <Card>
                <a href={article.pdfURL} target="_blank">
                    <CardActionArea onClick={this.handleArticleClick}>
                        <CardMedia style={styles.media} image={article.imageURL} alt={article.title} />
                        <CardContent>
                            <Typography gutterBottom variant="h5" componen="h2">
                                {article.title}
                            </Typography>
                            <Typography
                                variant="body2" 
                                color="textSecondary" 
                                component="p" >
                                by: {article.authorName}
                            </Typography>
                            <div className="tags">
                                {article.tags.map(t => (
                                    <Chip 
                                        style={styles.chip} 
                                        key={t} color="primary" 
                                        variant="outlined" 
                                        label={t} />
                                ))}
                            </div>
                            <Typography variant="caption">{ moment(article.time.seconds * 1000).fromNow() }</Typography>
                        </CardContent>
                    </CardActionArea>
                </a>
            </Card>
        )
    }
}

export default ArticleCard